import { createSlice } from '@reduxjs/toolkit';

const payoutLogSlice = createSlice({
  name: 'payoutLogSlice',
  initialState: {
    isLoading: false,
    payoutLogList: [],
    isError: null,
  },
  reducers: {
    requestPayoutLogList: (state) => {
      return { ...state, isLoading: true };
    },
    responsePayoutLogList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        payoutLogList: action?.payload?.data || [],
      };
    },
    failurePayoutLogList: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },
  },
});

export const {
  requestPayoutLogList,
  responsePayoutLogList,
  failurePayoutLogList,
} = payoutLogSlice.actions;

export default payoutLogSlice.reducer;
